import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import {  addStoreProductFromMasterCatalogAPI, deleteStoreProductAPI, fetchStoreProductDetailsAPI, fetchStoreProductsAPI } from '../apis/storeProducts'

const initialState = {
    products: [],
    loading: false,
    error: null,
    singleProduct: null,
}

export const fetchStoreProducts = createAsyncThunk(
    'storeProducts/fetchProducts',
    async ({  filters, payload} , { rejectWithValue }) => {
        try {
            const res = await fetchStoreProductsAPI(  filters, payload );
            return res;
        } catch (error) {
            return rejectWithValue(error.response?.data);
        }
    }
);

export const fetchStoreSingleProduct = createAsyncThunk(
    'storeProducts/fetchSingleProduct',
    async ({productId, storeId}, { rejectWithValue }) => {
        try {
            const res = await fetchStoreProductDetailsAPI({storeId, productId});
            return res;
        } catch (error) {
            return rejectWithValue(error.response?.data);
        }
    }
);

export const addStoreProductsFromMasterCatalog = createAsyncThunk(
    'storeProducts/addStoreProducts',
    async ({ products, storeId}, { rejectWithValue }) => {
        try {
            const res = await addStoreProductFromMasterCatalogAPI(products, storeId);
            return res;
        } catch (error) {
            return rejectWithValue(error.response?.data);
        }
    }
)

export const deleteStoreProduct = createAsyncThunk(
    'storeProducts/deleteProduct',
    async ({productId,storeId}, { rejectWithValue }) => {
        try {
            const res = await deleteStoreProductAPI({productId,storeId})
            return res;
        } catch (error) {
            return rejectWithValue(error.response?.data)
        }
    }
)

// Create a slice
const storeProductSlice = createSlice({
    name: 'storeProducts',
    initialState,
    reducers: {
        clearProducts: (state) => {
            state.products= [];
        },
    },
    extraReducers: (builder) => {
        builder
        .addCase(fetchStoreProducts.pending, (state) => {
            state.loading = true;
            state.error = null;
            state.singleProduct = {}
        })
        .addCase(fetchStoreProducts.fulfilled, (state, action) => {
            state.loading = false;
            state.products = action.payload;
        })
        .addCase(fetchStoreProducts.rejected, (state,action) => {
            state.loading = false;
            state.error = action.payload
        });
        builder
        .addCase(fetchStoreSingleProduct.pending, (state) => {
            state.loading = true;
            state.error = null;
        })
        .addCase(fetchStoreSingleProduct.fulfilled, (state, action) => {
            state.loading = false;
            state.singleProduct = action.payload;
        })
        .addCase(fetchStoreSingleProduct.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
        });

        builder
        .addCase(addStoreProductsFromMasterCatalog.pending, (state) => {
            state.isUpdating = true;
            state.error = null;
        })
        .addCase(addStoreProductsFromMasterCatalog.fulfilled, (state,action) => {
            state.isUpdating = false;
        })
        .addCase(addStoreProductsFromMasterCatalog.rejected, (state,action) => {
            state.isUpdating = false;
        });

    }
})

export const { } = storeProductSlice.actions;

export default storeProductSlice.reducer;